import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02f9c4ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "textarea-wrapper" }
const _hoisted_2 = ["placeholder", "autofocus", "maxlength", "rows", "readonly"]
const _hoisted_3 = { class: "appendage-wrapper" }
const _hoisted_4 = {
  "data-testid": "textarea-copy-value",
  class: "character-count"
}

import { computed, ref, watch } from 'vue'

import ClipboardCopy from '@/popup/components/shared/ClipboardCopy/ClipboardCopy.vue'
import {
  InputValidator,
  InputFormatter,
  InputError,
  InputSize,
} from '@/popup/components/shared/Form/FormTypes'

type Props = {
  value?: string
  errors?: InputError[]
  placeholder?: string
  size?: InputSize
  validators?: InputValidator[]
  validateOnBlur?: boolean
  autofocus?: boolean
  formatters?: InputFormatter[]
  maxlength?: number
  hasCounter?: boolean
  hasAutogrow?: boolean
  rows?: number
  textareaClass?: string
  hasCopy?: boolean
  readonly?: boolean
}

type Emits = {
  (event: 'on-enter', domEvent: Event, value: string): void
  (event: 'on-update', value: string): void
  (event: 'on-errors', errors: InputError[]): void
  (event: 'on-blur', value: string): void
  (event: 'on-key-down', value: KeyboardEvent): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Textarea',
  props: {
    value: { default: '' },
    errors: { default: undefined },
    placeholder: { default: '' },
    size: { default: 'medium' },
    validators: { default: undefined },
    validateOnBlur: { type: Boolean, default: true },
    autofocus: { type: Boolean, default: false },
    formatters: { default: undefined },
    maxlength: { default: undefined },
    hasCounter: { type: Boolean, default: false },
    hasAutogrow: { type: Boolean, default: false },
    rows: { default: 3 },
    textareaClass: { default: '' },
    hasCopy: { type: Boolean, default: false },
    readonly: { type: Boolean }
  },
  emits: ["on-enter", "on-update", "on-errors", "on-blur", "on-key-down"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const emits = __emit

const touched = ref(false)
const textarea = ref(props.value)
const errors = ref(props.errors)
const element = ref<HTMLTextAreaElement>()

const enter = (event: Event) => {
  format(textarea.value)
  validate(textarea.value)

  emits('on-enter', event, textarea.value)
}
const keyDown = (event: KeyboardEvent) => {
  emits('on-key-down', event)
}

const update = () => {
  format(textarea.value)

  if (!props.validateOnBlur || touched.value) {
    validate(textarea.value)
  }

  if (props.hasAutogrow) {
    resize()
  }
  emits('on-update', textarea.value)
}

const validate = (value: string) => {
  errors.value = value
    ? props.validators
        ?.map(validator => validator(value, element.value))
        .filter(Boolean)
    : []
  emits('on-errors', errors.value || [])
}

const format = (value: string) => {
  if (value && props.formatters)
    for (const formatter of props.formatters) textarea.value = formatter(value)
}

watch(props, () => {
  textarea.value = props.value
  errors.value = props.errors

  if (props.hasAutogrow) {
    setTimeout(() => {
      resize()
    })
  }

  if (props.autofocus && !touched.value && element.value) {
    element.value.focus()
  }
})

__expose({ validate })

const blur = () => {
  emits('on-blur', textarea.value)
  touched.value = true

  if (props.validateOnBlur) {
    validate(textarea.value)
  }
}

const hasErrors = computed(() => {
  return errors.value?.length
})

const resize = () => {
  if (element.value) {
    element.value.style.height = 'auto'
    element.value.style.height = `${element.value.scrollHeight}px`
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      ref_key: "element",
      ref: element,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textarea).value = $event)),
      class: _normalizeClass(`textarea is-${_ctx.size} ${hasErrors.value ? 'is-danger' : ''} ${
        _ctx.hasCounter ? 'has-counter' : ''
      } ${_ctx.hasAutogrow ? 'has-autogrow' : ''} ${_ctx.textareaClass}`),
      placeholder: _ctx.placeholder,
      autofocus: _ctx.autofocus,
      maxlength: _ctx.maxlength,
      rows: _ctx.rows,
      readonly: _ctx.readonly,
      "data-testid": "textarea",
      onKeypress: _withKeys(enter, ["enter"]),
      onKeydown: keyDown,
      onInput: update,
      onBlur: blur
    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2), [
      [_vModelText, textarea.value]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("span", { class: "character-count" }, _toDisplayString(textarea.value?.length || 0) + "/" + _toDisplayString(_ctx.maxlength), 513 /* TEXT, NEED_PATCH */), [
        [_vShow, _ctx.hasCounter]
      ]),
      _withDirectives(_createVNode(ClipboardCopy, {
        value: textarea.value,
        "offset-distance": "0",
        placement: "top"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('textarea.copy')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["value"]), [
        [_vShow, _ctx.hasCopy]
      ])
    ])
  ]))
}
}

})